const FaqHero = () => {
  return (
    <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/efe9db81209933e9b661a3aa17d51216.jpg"
          alt="Preguntas frecuentes"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-block px-6 py-2 bg-primary/10 text-primary rounded-full text-sm font-semibold mb-6">
          Preguntas frecuentes
        </span>
        
        <h1 className="text-5xl md:text-6xl font-bold text-graphite mb-6 leading-tight">
          Resolvemos tus <span className="text-primary">dudas</span>
        </h1>
        
        <p className="text-xl text-gray-medium leading-relaxed">
          Encuentra respuestas a las preguntas más comunes sobre nuestros servicios de vaciado de pisos, locales y limpieza extrema en Castelldefels
        </p>
      </div>
    </section>
  );
};

export default FaqHero;
